import {useEffect, useState} from 'react'
import {useForm} from "react-hook-form"
import InputWithLabel from 'elements/InputWithLabel'
import ButtonBigWithAction from 'elements/ButtonBigWithAction'
import LoadingIndicator from 'pages/LoadingIndicator'
import GetRequest from 'components/GetRequest'
import PostRequest from 'components/PostRequest'
import DeleteRequest from 'components/DeleteRequest'

const Iban = () => {

    const {register, handleSubmit, reset, formState: { errors }, setValue} = useForm({
        defaultValues: {
            bankName: null,
            iban: null
        }
    })

    const inputs = [
        {
            key: "ibanInput1",
            type: "text",
            name: "bankName",
            placeholder: "Zorunlu Alan",
            label: "Banka *",
            register: register,
            validator: {
                required: "Bu alan zorunludur.", 
                minLength: {value: 4, 
                            message: "En az 4 karakter olmalı"}, 
                maxLength: {value: 255, 
                            message:"En fazla 255 karakter olmalı"}
            },
            error: errors?.bankName?.message 
        },
        {
            key: "ibanInput2",
            type: "text",
            name: "iban",
            placeholder: "Zorunlu Alan",
            label: "IBAN *",
            register: register,
            validator: {
                required: "Bu alan zorunludur.", 
                minLength: {value: 4, 
                            message: "En az 4 karakter olmalı"}, 
                maxLength: {value: 255, 
                            message:"En fazla 255 karakter olmalı"}
            },
            error: errors?.iban?.message 
        },
    ]

    const [saveStatus, setSaveStatus] = useState()
    const [loading, setLoading] = useState(false)
    const [updatedIbanList, setUpdatedIbanList] = useState(false)
    const [ibans, setIbans] = useState([])

    useEffect(() => {
        setLoading(true)
        GetRequest('api/iban')
            .then(response => {
                var ibans = response.data.map(value => {
                    return {bankName: value.bankName, iban: value.iban, id: value.id}
                })
                setIbans(ibans)
                setLoading(false)
            })
            .catch(error => {
                console.log(error.response)
                setIbans([])
                setLoading(false)
            })
    }, [updatedIbanList])

    

    const handleForm = (data) => {
        setLoading(true)
        PostRequest('api/iban', data)
            .then(response => {
                
                const successMessage = (
                    <div className='text-sm text-green-100 bg-green-600 text-bold mb-2 p-1'>
                        <p>Bilgiler başarıyla kaydedildi.</p> 
                    </div>
                )
                setSaveStatus(successMessage)
                setUpdatedIbanList(!updatedIbanList)
                setLoading(false)
            })
            .catch(error => {
                const err = error.response.data.errors
                if(err) {
                    const errorItems = Object.keys(err).map((value, index) => {
                        return (
                            <li key={value.toString()}>{err[value][0]}</li>
                        )
                    })
                    const errorMessage = (
                        <div className='text-sm text-red-600'>
                            <p>{error.response.data.message}</p>   
                            <ul className='list-[circle] list-inside'>
                                {errorItems}
                            </ul>                     
                        </div>
                    )
                    setSaveStatus(errorMessage)
                } else {
                    const errorMessage = (
                        <div className='text-sm text-red-100 bg-red-600 text-bold mb-2 p-1'>
                            <p>{`${error.response.statusText} (${error.response.status})`}</p> 
                        </div>
                    )   
                    
                    setSaveStatus(errorMessage)
                }  
                setLoading(false)
            })
    }

    const handleDelete = (id) => {
        setLoading(true)
        DeleteRequest('api/iban/'+id)
            .then(response => {
                setUpdatedIbanList(!updatedIbanList)
                setLoading(false)
            })
            .catch(error => {
                const err = error.response.data.errors
                if(err) {
                    const errorItems = Object.keys(err).map((value, index) => {
                        return (
                            <li key={value.toString()}>{err[value][0]}</li>
                        )
                    })
                    const errorMessage = (
                        <div className='text-sm text-red-600'>
                            <p>{error.response.data.message}</p>   
                            <ul className='list-[circle] list-inside'>
                                {errorItems}
                            </ul>                     
                        </div>
                    )
                    setSaveStatus(errorMessage)
                } else {
                    const errorMessage = (
                        <div className='text-sm text-red-100 bg-red-600 text-bold mb-2 p-1'>
                            <p>{`${error.response.statusText} (${error.response.status})`}</p> 
                        </div>
                    )   
                    
                    setSaveStatus(errorMessage)
                }  
                setLoading(false)
            })
    }
    return (
        <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
            <div className='text-left mt-12'>
                <h2 className='text-2xl font-semibold text-gray-700 my-4 '>Banka Hesap Bilgileri</h2>
                <p className='text-md text-gray-700'> Bu alandan sistem sisteme Banka ve IBAN bilgilerinizi kaydedebilirisiniz. Kayıtlı banka hesap bilgileriniz faturalara not olarak eklenecektir.</p>
            </div>
            <div className='text-left'>
                <div className='h-12'>
                    {saveStatus}
                </div>
                <form onSubmit={handleSubmit(handleForm)}>
                {inputs.map((input, index) => {
                            return (
                                <div className='max-w-[400px]' key={`inputContainer${index}`}>                                    
                                        <InputWithLabel {...input} addClass="mt-2"/>
                                </div>
                            )
                        })  }
                    <ButtonBigWithAction type="submit" addClass="text-white bg-emerald-500 w-full max-w-[400px]" title="Kaydet" />
                </form>
                <div className='mt-4'>
                    <h3 className='pb-1 border-b border-gray-500 text-gray-700'>Kayıtlı Banka Bilgileri</h3>
                    <table className='w-full text-sm'>                        
                        <thead>
                            <tr className='text-center'>
                                <th >Banka</th>
                                <th>IBAN</th>
                                <th>Sil</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(ibans).length > 0 
                            ? ibans.map(value => {
                                return (
                                    <tr key={`bankinfo${value.id}`}>
                                        <td>{value.bankName}</td>
                                        <td>{value.iban}</td>
                                        <td className='text-center'>
                                            <button className='py-1 px-10 bg-red-600 text-red-50' onClick={() => handleDelete(value.id)}>Sil</button>
                                        </td>
                                    </tr>
                                )
                            })
                            : <tr><td>Kayıtlı banka bilgisi bulunamadı.</td></tr>
                            }
                        </tbody>                        
                    </table>
                </div>
            </div>
            
            {loading && <LoadingIndicator />}
                    
        </div>
    )
}

export default Iban